/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { GuideType, InteractiveComponents } from '../../../../core/enums';
import { ScreenTaskControllerTypes } from '../../../../core/navigation';
import { NetworkManager } from '../../../../core/network/NetworkManager';
import { resetCategoriesFilterAction } from '../../../overlay/channeloptionsoverlay/channeloptionsoverlay.actions';
import { FilteredGuideChannelOptionsOverlayActions } from '../../../overlay/channeloptionsoverlay/channeloptionsoverlay.enum';
import {
    channelOptionsOverlayAddRemoveFavoriteChannel,
    channelOptionsOverlayApplyFilter,
    onKeyBackChannelOptionsOverlay,
    userHasSelectedCategoryFilter,
} from '../../../overlay/channeloptionsoverlay/channeloptionsoverlay.reducers';
import { onKeyOkCreateOnePassOverlay } from '../../../overlay/createonepassoverlay/createonepassoverlay.reducres';
import {
    onKeyBackExitConfirmationOverlay,
    onKeyOkExitConfirmationOverlay,
} from '../../../overlay/exitconfirmationoverlay/exitconfirmationoverlay.reducers';
import { onKeyOkModifyOnePassOverlay } from '../../../overlay/modifyonepassoverlay/modifyonepassoverlay.reducers';
import {
    onKeyBackNoNetworkOverlay,
    onKeyOkNoNetworkOverlay,
} from '../../../overlay/nonetworkoverlay/nonetworkoverlay.reducers';
import {
    clearOnePassSharedPreference,
    onKeyOkDOCOverlay,
    onKeyOkOnePassOptionsOverlay,
} from '../../../overlay/onepassoptionsoverlay/onepassoptionsoverlay.reducers';
import { setOverlayHighlightVerticalPositionAction } from '../../../overlay/overlayhighlight/overlayhighlight.actions';
import { resetPCPinValuesAction } from '../../../overlay/pcpinoverlay/pcpinoverlay.actions';
import {
    hidePcPinOverlay,
    onKeyBackPcPinOverlay,
    onKeyDigitPcPinOverlay,
    onKeyOkPcPinOverlay,
} from '../../../overlay/pcpinoverlay/pcpinoverlay.reducers';
import {
    onKeyOkRecordingOverlay,
    onKeyOkStopOrCancelRecording,
} from '../../../overlay/recordingoverlay/recordingoverlay.reducers';
import {
    onKeyBackRecordOverlay,
    onKeyOkRecordOverlay,
} from '../../../overlay/recordoverlay/recordoverlay.reducers';
import {
    onKeyBackSocuErrorOverlay,
    onKeyOkSocuErrorOverlay,
} from '../../../overlay/socuerroroverlay/socuerroroverlay.reducres';
import { onKeyOkStorageLimitOverlay } from '../../../overlay/storagelimitoverlay/storagelimitoverlay.reducers';
import { onKeyBackVodResumeStartOverOverlay } from '../../../overlay/vodresumestartoveroverlay/vodresumestartoveroverlay.reducers';
import { hideOverlayDialog } from '../../../overlaydialog/overlaydialog.reducers';
import { showGuideScreen } from '../../../screens/screens.reducers';
import { showWhisper } from '../../../whisper/whisper.reducer';
import { onKeyOkEnterChannelNumber } from '../../enterchannelnumber/enterchannelnumber.reducers';
import {
    cancelGuideSpinnerOperations,
    onKeyBackGuideOperations,
    onKeyOkGuideOperations,
} from '../../guidenavigation/guidekeyoperations.reducers';
import { onSetFilteredGuideTurboScrollAction } from '../filteredguide.actions';
import {
    filteredGuideGetPreviewAndMetadata,
    filteredGuideWatchNowLiveProgram,
} from '../filteredguide.reducers';
import { onVerticalKeyPressFilteredGuideAction } from './filteredguide.navigation.actions';
import {
    dispatchOverlayVerticalKey,
    handleGuideErrorOrNetwork,
    handleHorizontalKeyNavigation,
    handleLongKeyChannelNavigation,
    handleLongKeyNavigation,
    onKeyOkDefaultTaskFilteredGuide,
    onKeyOkVodResumeStartOverOverlayFromFilteredGuide,
} from './navigation.utils';

export const onKeyBackFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(resetCategoriesFilterAction());
            dispatch(showGuideScreen());
            break;

        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
            dispatch(onKeyBackChannelOptionsOverlay());
            break;

        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            dispatch(onKeyBackGuideOperations());
            break;

        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
            dispatch(onKeyBackExitConfirmationOverlay());
            break;
        case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
            dispatch(onKeyBackNoNetworkOverlay());
            break;
        case ScreenTaskControllerTypes.PC_PIN_OVERLAY_TASK:
            dispatch(onKeyBackPcPinOverlay());
            break;
        case ScreenTaskControllerTypes.RECORD_OVERLAY_TASKS:
            dispatch(onKeyBackRecordOverlay());
            break;
        case ScreenTaskControllerTypes.SOCU_ERROR_OVERLAY_TASKS:
            dispatch(onKeyBackSocuErrorOverlay());
            break;
        case ScreenTaskControllerTypes.VOD_RESUME_START_OVER_OVERLAY_TASKS:
            dispatch(onKeyBackVodResumeStartOverOverlay());
            break;
        case ScreenTaskControllerTypes.STOP_RECORDING_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.CANCEL_RECORDING_OVERLAY_TASKS:
            dispatch(hideOverlayDialog());
            break;
        case ScreenTaskControllerTypes.CREATE_ONE_PASS_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.MODIFY_ONE_PASS_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SLO_TASKS:
        case ScreenTaskControllerTypes.ONE_PASS_OPTIONS_OVERLAY_TASK:
        case ScreenTaskControllerTypes.RECORDING_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.CANCEL_ONE_PASS_OVERLAY_TASKS:
            clearOnePassSharedPreference();
            dispatch(hideOverlayDialog());
            break;
        default:
    }
};

export const onKeyOkFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    const { isError } = getState().filteredGuide;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            if (handleGuideErrorOrNetwork(dispatch, isError)) return;
            dispatch(onKeyOkDefaultTaskFilteredGuide());
            break;

        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
            dispatch(onKeyOkChannelOptionsOverlay());
            break;

        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
            dispatch(onKeyOkExitConfirmationOverlay());
            break;
        case ScreenTaskControllerTypes.ENTER_CHANNEL_NUMBER:
            dispatch(onKeyOkEnterChannelNumber());
            break;
        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            dispatch(onKeyOkGuideOperations());
            break;
        case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
            dispatch(onKeyOkNoNetworkOverlay());
            break;
        case ScreenTaskControllerTypes.RECORD_OVERLAY_TASKS:
            dispatch(onKeyOkRecordOverlay());
            break;
        case ScreenTaskControllerTypes.SOCU_ERROR_OVERLAY_TASKS:
            dispatch(onKeyOkSocuErrorOverlay());
            break;
        case ScreenTaskControllerTypes.VOD_RESUME_START_OVER_OVERLAY_TASKS:
            dispatch(onKeyOkVodResumeStartOverOverlayFromFilteredGuide());
            break;
        case ScreenTaskControllerTypes.PC_PIN_OVERLAY_TASK:
            dispatch(onKeyOkPcPinOverlay());
            break;
        case ScreenTaskControllerTypes.CREATE_ONE_PASS_OVERLAY_TASKS:
            dispatch(onKeyOkCreateOnePassOverlay());
            break;
        case ScreenTaskControllerTypes.MODIFY_ONE_PASS_OVERLAY_TASKS:
            dispatch(onKeyOkModifyOnePassOverlay());
            break;
        case ScreenTaskControllerTypes.SLO_TASKS:
            dispatch(onKeyOkStorageLimitOverlay());
            break;
        case ScreenTaskControllerTypes.ONE_PASS_OPTIONS_OVERLAY_TASK:
            dispatch(onKeyOkOnePassOptionsOverlay());
            break;
        case ScreenTaskControllerTypes.RECORDING_OVERLAY_TASKS:
            dispatch(onKeyOkRecordingOverlay());
            break;
        case ScreenTaskControllerTypes.STOP_RECORDING_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.CANCEL_RECORDING_OVERLAY_TASKS:
            dispatch(onKeyOkStopOrCancelRecording());
            break;
        case ScreenTaskControllerTypes.CANCEL_ONE_PASS_OVERLAY_TASKS:
            dispatch(onKeyOkDOCOverlay());
            break;

        default:
    }
};

export const onLongKeyOkFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(onKeyOkDefaultTaskFilteredGuide(true, false));
            break;
        default:
    }
};

export const onKeyUpFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { verticalPosition, isError } = getState().filteredGuide;
    const { screenTaskController } = getState().screens;

    const newVerticalPosition = verticalPosition - 1;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            if (handleGuideErrorOrNetwork(dispatch, isError)) return;
            dispatch(onVerticalKeyPressFilteredGuideAction(newVerticalPosition));
            break;
        default:
            dispatchOverlayVerticalKey(dispatch, screenTaskController, 'up');
    }
};

export const onLongKeyUpFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    handleLongKeyNavigation(dispatch, screenTaskController, InteractiveComponents.NORTH);
};

export const onLongKeyDownFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    handleLongKeyNavigation(dispatch, screenTaskController, InteractiveComponents.SOUTH);
};

export const onKeyLeftFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { isError } = getState().filteredGuide;
    const { screenTaskController } = getState().screens;
    handleHorizontalKeyNavigation(dispatch, isError, screenTaskController, 'left');
};

export const onKeyRightFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { isError } = getState().filteredGuide;
    const { screenTaskController } = getState().screens;
    handleHorizontalKeyNavigation(dispatch, isError, screenTaskController, 'right');
};

export const onKeyDownFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { verticalPosition, isError } = getState().filteredGuide;
    const { screenTaskController } = getState().screens;

    const newVerticalPosition = verticalPosition + 1;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            if (handleGuideErrorOrNetwork(dispatch, isError)) return;
            dispatch(onVerticalKeyPressFilteredGuideAction(newVerticalPosition));
            break;
        default:
            dispatchOverlayVerticalKey(dispatch, screenTaskController, 'down');
    }
};

export const onKeyInfoFilteredGuide = () => async (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            if (NetworkManager.isNetworkDisconnected()) {
                dispatch(showWhisper());
                return;
            }
            dispatch(cancelGuideSpinnerOperations());
            dispatch(onKeyOkDefaultTaskFilteredGuide(true, true));
            break;
        default:
    }
};

export const onKeyDigitFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
        case ScreenTaskControllerTypes.RECORD_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.VOD_RESUME_START_OVER_OVERLAY_TASKS:
            dispatch(hideOverlayDialog());
            break;

        case ScreenTaskControllerTypes.PC_PIN_OVERLAY_TASK:
            dispatch(onKeyDigitPcPinOverlay());
            break;
        default:
    }
};

export const onKeyGuideFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.PC_PIN_OVERLAY_TASK:
            dispatch(resetPCPinValuesAction());
            dispatch(hidePcPinOverlay());
            break;
        default:
    }
};

export const onKeyOkChannelOptionsOverlay =
    () => async (dispatch: Function, getState: Function) => {
        const { verticalPosition, horizontalPosition } = getState().overlayHighlight;
        const { selectedProgram } = getState().filteredGuide;

        const categoriesFilterIndex =
            FilteredGuideChannelOptionsOverlayActions.CATEOGORIES_FILTER_PILL;
        const channelsFilterIndex = FilteredGuideChannelOptionsOverlayActions.CHANNELS_FILTER_PILL;
        const filterButtonIndex =
            FilteredGuideChannelOptionsOverlayActions.VIEW_GUIDE_WITH_SELECTED_FILTERS;

        const userSelectedCategoryFilterValue = userHasSelectedCategoryFilter(
            categoriesFilterIndex,
            horizontalPosition,
        );

        const { isExplicitlyAdult, channel } = await filteredGuideGetPreviewAndMetadata(
            getState().filteredGuide,
            getState().channelOptionsOverlay,
        );

        if (NetworkManager.isNetworkDisconnected()) {
            dispatch(showWhisper());
            return;
        }

        if (!channel) {
            return;
        }

        if (verticalPosition === FilteredGuideChannelOptionsOverlayActions.WATCH_NOW) {
            dispatch(
                filteredGuideWatchNowLiveProgram(
                    channel,
                    isExplicitlyAdult ?? selectedProgram.isAdult,
                    true,
                ),
            );
        } else if (
            verticalPosition ===
            FilteredGuideChannelOptionsOverlayActions.FAVORITE_CHANNEL_ADD_REMOVE
        ) {
            dispatch(channelOptionsOverlayAddRemoveFavoriteChannel(GuideType.FILTERED_GUIDE));
        } else if (verticalPosition === filterButtonIndex) {
            dispatch(channelOptionsOverlayApplyFilter(categoriesFilterIndex, channelsFilterIndex));

            if (userSelectedCategoryFilterValue) {
                return;
            }

            dispatch(showGuideScreen());
        } else {
            dispatch(setOverlayHighlightVerticalPositionAction(filterButtonIndex));
        }
    };

export const onLongKeyChannelUpFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { isError } = getState().filteredGuide;
    const { screenTaskController } = getState().screens;
    handleLongKeyChannelNavigation(dispatch, isError, screenTaskController, 'up');
};

export const onLongKeyChannelDownFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { isError } = getState().filteredGuide;
    const { screenTaskController } = getState().screens;
    handleLongKeyChannelNavigation(dispatch, isError, screenTaskController, 'down');
};

export const onLongKeyStopFilteredGuide =
    () =>
    (dispatch: Function, getState: Function): void => {
        const { filteredGuideTurboScroll } = getState().filteredGuide;

        if (filteredGuideTurboScroll) {
            dispatch(onSetFilteredGuideTurboScrollAction(false, InteractiveComponents.NORTH));
        }
    };
